import React from 'react';
export default function BackFaceRibbon() {
  return /*#__PURE__*/React.createElement("div", {
    className: "back-face-ribbon"
  });
}